import { useEffect, useState } from "react";
import { api, formatApiError } from "@/context/AuthContext";

export default function PracticeHoursCard({ programmeId = "programme-nz-road-code" }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [minutes, setMinutes] = useState(60);
  const [date, setDate] = useState("");

  useEffect(() => {
    api
      .get("/practice-hours/learner/summary", { params: { programme_id: programmeId } })
      .then((res) => setData(res.data))
      .catch((err) => setError(formatApiError(err)));
  }, [programmeId]);

  async function submitSelfPractice(e) {
    e.preventDefault();
    setError("");
    try {
      await api.post("/practice-hours/learner/entries", {
        practice_date: date,
        duration_minutes: Number(minutes),
        entry_type: "learner_self_reported",
        programme_id: programmeId,
      });
      const res = await api.get("/practice-hours/learner/summary", { params: { programme_id: programmeId } });
      setData(res.data);
    } catch (err) {
      setError(formatApiError(err));
    }
  }

  if (!data) return null;
  const s = data.summary || {};

  return (
    <section className="card space-y-3" data-testid="practice-hours-card">
      <h2 className="text-base font-semibold">{data.config?.label || "GDI practice target"}</h2>
      <p className="text-sm text-muted-foreground">
        Confirmed {s.credited_hours ?? 0} h of {s.target_hours ?? 60} h target ({s.remaining_hours ?? 0} h remaining).
        Unconfirmed: {Math.round((s.unconfirmed_minutes || 0) / 60)} h.
      </p>
      <form className="flex flex-wrap gap-2 items-end" onSubmit={submitSelfPractice}>
        <label className="text-sm">
          Date
          <input className="input" required type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </label>
        <label className="text-sm">
          Minutes
          <input className="input w-24" type="number" min={1} value={minutes} onChange={(e) => setMinutes(e.target.value)} />
        </label>
        <button type="submit" className="btn-outline">Log practice</button>
      </form>
      {error && <p className="text-destructive text-sm">{error}</p>}
    </section>
  );
}
